<template>
  <main-dialog
    id="log-export-modal"
    :title="$t('logExport.title.' + (includeScreenshot ? 'withScreenshot' : 'logsOnly'))"
    :ok-title="$t('logExport.exportButton.' + (includeScreenshot ? 'withScreenshot' : 'logsOnly'))"
    :cancel-title="$t('logExport.cancel')"
    @ok="handleOk"
    centered
    size="md"
  >
    <div class="text-center mb-3">
      <i :class="iconClass" style="font-size: 3rem;"></i>
    </div>
    
    <p class="mb-3">{{ $t('logExport.description.' + (includeScreenshot ? 'withScreenshot' : 'logsOnly')) }}</p>
    
    <div class="export-info">
      <h6>{{ $t('logExport.whatWillBeExported') }}:</h6>
      <ul>
        <li v-if="includeScreenshot">
          <i class="bi bi-camera-fill text-primary"></i> 
          {{ $t('logExport.items.screenshot') }}
        </li>
        <li>
          <i class="bi bi-file-text-fill text-info"></i> 
          {{ $t('logExport.items.logs', { count: logsCount, size: logsSize }) }}
        </li>
        <li>
          <i class="bi bi-info-circle-fill text-secondary"></i> 
          {{ $t('logExport.items.browserInfo') }}
        </li>
        <li>
          <i class="bi bi-link-45deg text-secondary"></i> 
          {{ $t('logExport.items.url') }}
        </li>
        <li v-if="comment">
          <i class="bi bi-chat-left-text-fill text-warning"></i> 
          {{ $t('logExport.items.comment') }}
        </li>
      </ul>
    </div>
    
    <div class="mt-3">
      <b-form-group
        :label="$t('logExport.commentLabel')"
        label-for="log-comment"
        :description="$t('logExport.commentDescription')"
      >
        <b-form-textarea
          id="log-comment"
          v-model="comment"
          :placeholder="$t('logExport.commentPlaceholder')"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>
    </div>
    
    <b-alert show variant="info" class="mb-0 mt-3">
      <small>
        <i class="bi bi-shield-check"></i>
        {{ $t('logExport.privacyNote') }}
      </small>
    </b-alert>
  </main-dialog>
</template>

<script>
export default {
  name: 'LogExportModal',
  props: {
    includeScreenshot: {
      type: Boolean,
      default: false
    },
    logsCount: {
      type: Number,
      default: 0
    },
    logsSize: {
      type: String,
      default: '0 KB'
    }
  },
  data() {
    return {
      comment: ''
    };
  },
  computed: {
    iconClass() {
      return this.includeScreenshot 
        ? 'bi bi-camera-fill text-primary' 
        : 'bi bi-file-earmark-arrow-down-fill text-success';
    }
  },
  methods: {
    handleOk(bvModalEvent) {
      this.$emit('confirm', this.comment);
      // Reset comment for next time
      this.comment = '';
    }
  },
  watch: {
    // Reset comment when modal is opened
    '$root.$data.logExportModalVisible': function(newVal) {
      if (newVal) {
        this.comment = '';
      }
    }
  }
}
</script>

<style scoped lang="scss">
.export-info {
  background-color: var(--form-bg);
  padding: 15px;
  border-radius: 8px;
  
  h6 {
    margin-bottom: 10px;
    font-weight: 600;
  }
  
  ul {
    margin-bottom: 0;
    padding-left: 20px;
    
    li {
      margin-bottom: 8px;
      
      i {
        margin-right: 8px;
      }
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
